<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta" :style="{ color: corTexto }">
          Meu Carrinho
        </h1>
        <table class="table is-striped">
          <thead>
            <tr>
              <th>
                <label class="cor-preta" :style="{ color: corTexto }"><b>Pedido</b></label>
              </th>
              <th>
                <label class="cor-preta" :style="{ color: corTexto }"><b>Preço</b></label>
              </th>
              <!--<th><b>Subtotal</b></th>-->
              <th><b></b></th>
              <th scope="row">
                <label class="cor-preta" :style="{ color: corTexto }"><b></b></label>
              </th>
            </tr>
          </thead>
          <tbody v-for="(p, index) in products" :key="index" style="overflow-wrap: anywhere">
            <tr>
              <td>
                <label class="cor-preta" :style="{ color: corTexto }"><b>{{ p.nm }} </b></label>
              </td>
              <!--<td><b>R$ {{ parseFloat(totalp = p.vl * p.quantity).toFixed(2) }}</b></td>-->
              <td>
                <label class="cor-preta" :style="{ color: corTexto }"><b>R$ {{ p.vl }}</b></label>
              </td>
              <td v-if="p.unitario == '1'">
                <div id="botoesMaisMenos">
                  <button @click="menosqtd(index)" class="btn btn-dark">
                    -
                  </button>
                  <label class="cor-preta"><b>{{ p.quantity }}</b></label>
                  <button @click="somarqtd(index)" class="btn btn-dark">
                    +
                  </button>
                </div>
              </td>
              <td v-if="p.unitario == '0'">
                <div style="display: flex; justify-content: center">
                  <input type="number" v-model="p.peso" class="form-control" id="text" aria-describedby="textHelp"
                    placeholder="Digite o peso" />
                </div>
              </td>
              <td>
                <button @click="removeFromCart(index)" class="btn btn-danger">
                  X
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <label class="letra-media cor-preta" :style="{ color: corTexto }">
                  <div v-if="p.adicionaispergunta.length > 0">
                    <p v-for="(a, idx) in p.adicionaispergunta" :key="idx">
                      {{
                        idx == p.adicionaispergunta.length - 1
                          ? a.nm != ""
                            ? a.nm + (p.obs != "" ? " | " + p.obs : "")
                            : p.obs
                          : a.nm + ","
                      }}
                    </p>
                  </div>
                  <div v-else>
                    <p>{{ p.obs }}</p>
                  </div>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
        <!--<b><span v-show="products.length">Total Produto: R$ {{ parseFloat(totalp).toFixed(2) }}</span></b><br><br>-->
        <h4>
          <b><label class="cor-preta" :style="{ color: corTexto }">Total: R$ {{ parseFloat(total).toFixed(2)
              }}</label></b>
        </h4>
        <br />
        <!--<b>Alguma observação ?</b>
			<textarea class="form-control" v-model="obs" id="obs" name="obs" rows="1" placeholder="Ex: Digite as observações aqui..."></textarea><br>-->
        <!--<h5>Pedido na <div id="minhadiv"></div></h5><br>-->
        <table border="0">
          <thead>
            <tr>
              <td width="350" valign="top">
                <li align="left">
                  <router-link style="background-color: #dc3545" to="/" class="btn btn-dark">Continuar
                    Pedido</router-link>
                </li>
              </td>
              <td width="100">
                <li align="center"></li>
              </td>
              <td width="480" valign="top">
                <li align="right">
                  <!--<button @click='salvarvendaproduto(products, total)' class="btn btn-dark">Confirmar Pedido</button>-->
                  <!--<button class='btn btn-dark' @click='listarendereco=true, products, total, listarpedidosvenda(vendaspedidos)' data-toggle="modal" data-target="#listandoendereco">Confirmar Pedido</button>-->
                  <button style="background-color: #006400" @click="salvarvendaproduto(products, total)"
                    class="btn btn-dark">
                    Confirmar Pedido
                  </button>
                </li>
              </td>
            </tr>
          </thead>
        </table>

        <!--<p><router-link to='/' class="btn btn-dark">Continuar Pedido</router-link></p><br>
			<p><button @click='salvarvendaproduto(products, total)'><router-link to='/pedidos' class="btn btn-dark">Confirmar Pedido</router-link></button></p><br>-->
      </div>
    </div>
  </div>
</template>

<style scoped>
#botoesMaisMenos {
  display: flex;
  justify-content: space-between;
}

.table td {
  border: none;
}

.table th:hover {
  background-color: #fff;
}

@media (max-width: 500px) {
  #botoesMaisMenos {
    display: flex;
    justify-content: space-between;
    min-width: 100px;
  }
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import Venda from "../services/venda";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
import api from "../services/api";
import Cardapio from "../services/cardapio";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Cart",
  data() {
    return {
      corFundo: "",
      corBotao: "",
      corTexto: "",
      adicionais: [],
      qrcodeDados: "",
      possuiAsaas: false,
      pagamentoOnline: "",
      qrCodeTempoExpiracao: 0,
      estoque: "",
    };
  },
  computed: {
    ...mapGetters({
      nome: "retornaNome",
      cpf: "retornaCPF",
      email: "retornaEmail",
      telefone: "retornaTelefone",
      products: "cartProducts",
    }),
    total() {
      return this.products.reduce((total, p) => {
        if (p.vl_promoSemAdd > 0) {
          if (p.vl_promo > 0) {
            return (
              total +
              p.quantity *
              (p.unitario == "0" ? p.peso * p.vl_promo : p.vl_promo)
            );
          } else {
            return (
              total +
              p.quantity *
              (p.unitario == "0"
                ? p.peso * p.vl_promoSemAdd
                : p.vl_promoSemAdd)
            );
          }
        } else {
          return (
            total + p.quantity * (p.unitario == "0" ? p.peso * p.vl : p.vl)
          );
        }
      }, 0);
    },
  },
  methods: {
    listarinis() {
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corFundo = response.data[0].vl;
      });
      cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corBotao = response.data[0].vl;
      });
      cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((response) => {
        this.corTexto = response.data[0].vl;
      });
      cd = "QRCODE_DADOS_CART";
      Inis.listarInisCd(cd).then((response) => {
        this.qrcodeDados = response.data[0].vl;
      });
      var cd = "TEMPO_QRCODE";
      Inis.listarInisCd(cd).then((response) => {
        this.qrCodeTempoExpiracao = response.data[0].vl;
      });
      Inis.listarInisCd("POSSUI_ASAAS").then((response) => {
        this.possuiAsaas = response.data[0].vl === "1" ? true : false;
      });
      Inis.listarInisCd("PAGAMENTO_ONLINE").then((response) => {
        this.pagamentoOnline = response.data[0].vl;
      });
      Inis.listarInisCd("CONTROLA_ESTOQUE").then((response) => {
        this.estoque = response.data[0].vl;
      });
    },
    listandoArrayPesos() {
      this.products.forEach((produto) => {
        if (produto.peso) {
          this.pesos.push(produto.peso);
        } else {
          if (produto.unitario == 0) {
            produto.peso = 1;
          } else {
            produto.peso = 0;
          }
        }
      });
    },
    async salvarvendaproduto(products) {
      var d1 = this.$store.state.date_token;
      var d2 = moment().format("YYYY-MM-DD hh:mm:ss");
      var diff = moment(d2, "YYYY-MM-DD HH:mm:ss").diff(
        moment(d1, "YYYY-MM-DD HH:mm:ss")
      );
      diff = diff / 60000;

      if (this.$store.state.funcionamento === "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
        //alert("Estabelecimento Fechado");
      } else if (diff > this.qrCodeTempoExpiracao) {
        Swal.fire({
          title: "Tempo de conexão expirou! Leia o QRcode novamente!",
          confirmButtonColor: "#000000",
        });
      } else if (
        this.qrcodeDados == "1" &&
        this.nome == "" &&
        this.telefone == ""
      ) {
        this.modalDados(products);
      } else {
        var v = new Object();

        if (this.estoque == "1") {
          let qtdVendidaPorProduto = [];

          for (let i = 0; i < products.length; i++) {
            const produtoAtual = products[i];
            const quantidadeVendida = products
              .filter((p) => p.cd === produtoAtual.cd)
              .reduce((total, p) => total + parseInt(p.quantity), 0);

            qtdVendidaPorProduto.push({
              cd: produtoAtual.cd,
              nm: produtoAtual.nm,
              quantidadeVendida,
            });
          }

          qtdVendidaPorProduto = qtdVendidaPorProduto.filter(
            (obj, index, self) =>
              index === self.findIndex((t) => t.cd === obj.cd)
          );

          for (let i = 0; i < qtdVendidaPorProduto.length; i++) {
            const produto = qtdVendidaPorProduto[i];

            const resposta = await Cardapio.listarQtd(produto.cd);
            const estoqueAtual = parseFloat(resposta.data[0].estoque);

            if (produto.quantidadeVendida > estoqueAtual) {
              Swal.fire({
                title:
                  `Produto "${produto.nm}" tem no máximo ${estoqueAtual} unidades restantes.`,
                confirmButtonColor: "#006400",
              });
              this.quantidadeInvalida = true;
              return;
            }

            const e = {
              cd: produto.cd,
              qtd: estoqueAtual - produto.quantidadeVendida,
            };

            await Cardapio.alteraQtd(e);
          }
        }


        if (
          this.$store.state.serie == "COMANDA" ||
          this.$store.state.serie == "comanda" ||
          this.$store.state.serie == "CARTAO" ||
          this.$store.state.serie == "cartao"
        ) {
          const { value: mesa } = await Swal.fire({
            title: "Qual o número da mesa que você está ?",
            input: "text",
            inputPlaceholder: "Ex: 1",
            confirmButtonColor: "#006400",
            cancelButtonColor: "#dc3545",
            showCancelButton: true,
            reverseButtons: true,
          });

          var resposta = mesa;
          v.mesa = resposta;
          v.serie = this.$store.state.serie;
          v.num_serie = this.$store.state.num_serie;

          v.total = this.products.reduce((total, p) => {
            let somatorio = 0;
            if (this.products.vl_promo > 0) {
              somatorio =
                total +
                p.quantity *
                (p.unitario == "0" ? p.peso * p.vl_promo : p.vl_promo);
              if (p.unitario == "0") {
                p.quantity = p.peso;
              }
              return somatorio;
            } else {
              somatorio =
                total +
                p.quantity * (p.unitario == "0" ? p.peso * p.vl : p.vl);

              if (p.unitario == "0") {
                p.quantity = p.peso;
              }
              return somatorio;
            }
          }, 0);
        } else {
          if (
            this.$store.state.serie == "MESA" ||
            this.$store.state.serie == "mesa"
          ) {
            v.mesa = null;
            v.serie = this.$store.state.serie;
            v.num_serie = this.$store.state.num_serie;
            v.total = this.products.reduce((total, p) => {
              let somatorio = 0;
              if (this.products.vl_promo > 0) {
                somatorio =
                  total +
                  p.quantity *
                  (p.unitario == "0" ? p.peso * p.vl_promo : p.vl_promo);
                if (p.unitario == "0") {
                  p.quantity = p.peso;
                }
                return somatorio;
              } else {
                somatorio =
                  total +
                  p.quantity * (p.unitario == "0" ? p.peso * p.vl : p.vl);

                if (p.unitario == "0") {
                  p.quantity = p.peso;
                }
                return somatorio;
              }
            }, 0);
          }
        }

        v.products = products;

        if (this.$store.state.serie == "COMANDA" && v.mesa < 1) {
          Swal.fire({
            title: "Por favor, preencha o número da mesa.",
            confirmButtonColor: "#000000",
          });
        } else {
          if (
            this.$store.state.serie == "COMANDA" &&
            (v.mesa == null || v.mesa == "")
          ) {
            Swal.fire({
              title: "Por favor, preencha o número da mesa.",
              confirmButtonColor: "#000000",
            });
          } else {
            if (this.$store.state.serie == "COMANDA" && isNaN(v.mesa)) {
              Swal.fire({
                title: "Digite apenas números!",
                confirmButtonColor: "#000000",
              });
            } else {
              if (this.$store.state.serie == "COMANDA" && v.mesa == "0") {
                Swal.fire({
                  title: "Por favor, preencha o número da mesa.",
                  confirmButtonColor: "#000000",
                });
              } else {
                if (this.products == "") {
                  Swal.fire({
                    title: "Por favor, escolha um produto do cardápio.",
                    confirmButtonColor: "#000000",
                  });
                } else {
                  if (
                    this.$store.state.serie == "" ||
                    this.$store.state.num_serie == "" ||
                    this.$store.state.serie == null ||
                    this.$store.state.num_serie == null
                  ) {
                    Swal.fire({
                      title: "Por favor, escolha um QR CODE da mesa.",
                      confirmButtonColor: "#000000",
                    });
                  } else {
                    if (this.qrcodeDados == "1") {
                      if (v.mesa == null) {
                        v.mesa = `Nome: ${this.nome}\nTelefone: ${this.telefone}`;
                      } else {
                        v.mesa += `\nNome: ${this.nome}\nTelefone: ${this.telefone}`;
                      }
                    }

                    if (
                      this.possuiAsaas &&
                      (this.pagamentoOnline === "2" ||
                        this.pagamentoOnline === "3")
                    ) {
                      this.$store.commit("setTotal", v.total);
                      this.$store.commit("setMesa", v.mesa);
                      this.$router.push("/pagamento");
                    } else {
                      Venda.salvarvenda(v)
                        .then(function (response) {
                          Swal.fire({
                            title: response.data,
                            confirmButtonColor: "#000000",
                          });
                        })
                        .catch(function (error) {
                          alert(error);
                        });
                      this.$store.commit("setZera", []);
                      this.$router.push("/");
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    validarCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, "");

      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
        return false;
      }

      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = 11 - (soma % 11);
      let digito1 = resto >= 10 ? 0 : resto;

      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = 11 - (soma % 11);
      let digito2 = resto >= 10 ? 0 : resto;

      return (
        digito1 === parseInt(cpf.charAt(9)) &&
        digito2 === parseInt(cpf.charAt(10))
      );
    },
    async modalDados(products) {
      if (
        this.possuiAsaas &&
        (this.pagamentoOnline === "2" || this.pagamentoOnline === "3")
      ) {
        const { value: cpf } = await Swal.fire({
          title: "Qual seu CPF?",
          input: "text",
          inputPlaceholder: "000.000.000-00",
          confirmButtonText: "Ok",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          reverseButtons: true,
          inputValidator: (value) => {
            if (!value) return "Por favor insira o seu CPF!";
            if (!this.validarCPF(value))
              return "Por favor insira um CPF válido!";
          },
        });

        if (!cpf) {
          return;
        }

        try {
          const response = await api.post("/qrcode/verify-cadastro", {
            contrato: process.env.VUE_APP_CONTRATO,
            cpf: cpf.replaceAll(/[\D]/g, ""),
          });

          Swal.fire({
            title: "Cadastro encontrado:",
            html: `Nome: ${response.data.nm}<br>CPF: ${response.data.cpf}<br>Email: ${response.data.email}<br>Telefone: ${response.data.fone}`,
            confirmButtonText: "OK",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            reverseButtons: true,
          }).then((result) => {
            // Função a ser executada quando o botão de confirmar é pressionado
            if (result.isConfirmed) {
              this.$store.commit("setNome", response.data.nm);
              this.$store.commit("setCPF", response.data.cpf);
              this.$store.commit("setEmail", response.data.email);
              this.$store.commit("setTelefone", response.data.fone);
              this.salvarvendaproduto(products);
            } else {
              this.$store.commit("setNome", "");
              this.$store.commit("setCPF", "");
              this.$store.commit("setEmail", "");
              this.$store.commit("setTelefone", "");
            }
          });
          return;
        } catch { }

        Swal.mixin({
          input: "text",
          confirmButtonText: "Próximo",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          progressSteps: ["1", "2", "3"],
          reverseButtons: true,
        })
          .queue([
            {
              title: "Digite seu nome completo",
              text: "Nome:",
              inputValidator: (value) => {
                if (!value) {
                  return "Nome é obrigatório!";
                }
              },
            },
            {
              title: "Digite seu Email",
              text: "Email:",
              inputValidator: (value) => {
                const regex =
                  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                if (!value.match(regex)) {
                  return "Email inválido!";
                }
              },
            },
            {
              title: "Digite seu telefone",
              text: "Telefone:",
              inputValidator: (value) => {
                const regex = /^\d{10,11}$/;
                if (!value.match(regex)) {
                  return "Telefone inválido!<BR/> Digite apenas números.";
                }
              },
            },
          ])
          .then((result) => {
            if (!result.dismiss) {
              const [nome, email, telefone] = result.value;

              this.$store.commit("setNome", nome);
              this.$store.commit("setCPF", cpf.replaceAll(/[\D]/g, ""));
              this.$store.commit("setEmail", email);
              if (telefone.length == 11) {
                this.$store.commit(
                  "setTelefone",
                  telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
                );
              } else if (telefone.length == 10) {
                this.$store.commit(
                  "setTelefone",
                  telefone.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
                );
              }
              Swal.fire({
                title: "Dados inseridos:",
                html: `Nome: ${this.nome}<br>CPF: ${this.cpf}<br>Email: ${this.email}<br>Telefone: ${this.telefone}`,
                confirmButtonText: "OK",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                reverseButtons: true,
              }).then((result) => {
                // Função a ser executada quando o botão de confirmar é pressionado
                if (result.isConfirmed) {
                  this.$store.commit("setNome", this.nome);
                  this.$store.commit("setCPF", this.cpf);
                  this.$store.commit("setEmail", this.email);
                  this.$store.commit("setTelefone", this.telefone);
                  this.salvarvendaproduto(products);
                } else {
                  this.$store.commit("setNome", "");
                  this.$store.commit("setCPF", "");
                  this.$store.commit("setEmail", "");
                  this.$store.commit("setTelefone", "");
                }
              });
            }
          });
      } else {
        Swal.mixin({
          input: "text",
          confirmButtonText: "Próximo",
          confirmButtonColor: "#000000",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          progressSteps: ["1", "2"],
          reverseButtons: true,
        })
          .queue([
            {
              title: "Digite seu nome completo",
              text: "Nome:",
              inputValidator: (value) => {
                if (!value) {
                  return "Nome é obrigatório!";
                }
              },
            },
            {
              title: "Digite seu telefone",
              text: "Telefone:",
              inputValidator: (value) => {
                const regex = /^\d{10,11}$/;
                if (!value.match(regex)) {
                  return "Telefone inválido!<BR/> Digite apenas números.";
                }
              },
            },
          ])
          .then((result) => {
            if (!result.dismiss) {
              const [nome, telefone] = result.value;

              this.$store.commit("setNome", nome);
              if (telefone.length == 11) {
                this.$store.commit(
                  "setTelefone",
                  telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
                );
              } else if (telefone.length == 10) {
                this.$store.commit(
                  "setTelefone",
                  telefone.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
                );
              }
              Swal.fire({
                title: "Dados inseridos:",
                html: `Nome: ${this.nome}<br>Telefone: ${this.telefone}`,
                confirmButtonText: "OK",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                reverseButtons: true,
              }).then((result) => {
                // Função a ser executada quando o botão de confirmar é pressionado
                if (result.isConfirmed) {
                  this.$store.commit("setNome", this.nome);
                  this.$store.commit("setTelefone", this.telefone);
                  this.salvarvendaproduto(products);
                } else {
                  this.$store.commit("setNome", "");
                  this.$store.commit("setTelefone", "");
                }
              });
            }
          });
      }
    },
    ...mapActions([
      "removeFromCart",
      "removeFromCartAd",
      "somarqtd",
      "menosqtd",
    ]),
  },
  mounted() {
    this.listarinis();
    this.listandoArrayPesos();
  },
};
</script>
